import * as XLSX from 'xlsx-js-style'

const formatNumber = (value: number): number => {
  return value
}

export const processSubActivities = (
  activities: Array<Record<string, any>>,
  subHeaders: { label: string; value: string; placement: string }[],
) => {
  const rows: Array<Record<string, any>> = []
  const levels: Array<{ level: number }> = [{ level: 0 }]

  activities.forEach(activity => {
    const subActivities = activity.subActivities
    delete activity.subActivities

    const formattedActivity = { ...activity }
    Object.keys(formattedActivity).forEach(key => {
      if (typeof formattedActivity[key] === 'number') {
        formattedActivity[key] = formatNumber(formattedActivity[key])
      }
    })

    rows.push(formattedActivity)
    levels.push({ level: 0 })

    // Sub activity rows (level 1)
    if (subActivities && subActivities.length > 0) {
      const subHeaderRow: Record<string, any> = {}

      subHeaders.forEach(header => {
        subHeaderRow[header.placement] = header.label
      })

      rows.push(subHeaderRow)
      levels.push({ level: 1 })

      subActivities.forEach((subActivity: Record<string, any>) => {
        const subActivityRow: Record<string, any> = {}

        subHeaders.forEach(header => {
          const rawValue = subActivity[header.value] !== undefined ? subActivity[header.value] : ''

          if (typeof rawValue === 'number') {
            subActivityRow[header.placement] = formatNumber(rawValue)
          } else {
            subActivityRow[header.placement] = rawValue
          }
        })

        rows.push(subActivityRow)
        levels.push({ level: 1 })
      })
    }
  })

  return { rows, levels }
}

export const applySubActivityStyles = (
  ws: XLSX.WorkSheet,
  range: XLSX.Range,
  rows: Array<Record<string, any>>,
  levels: Array<{ level: number }>,
  subHeaders: { label: string; value: string; placement: string }[],
) => {
  for (let R = range.s.r; R <= range.e.r; ++R) {
    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cellAddress = XLSX.utils.encode_cell({ r: R, c: C })
      const cell = ws[cellAddress] || {}
      const level = levels[R]?.level ?? 0

      if (R === 0) {
        cell.s = {
          font: { bold: true, name: 'Calibri', sz: 11 },
          border: { bottom: { style: 'thin', color: { rgb: '000000' } } },
        }
      } else if (
        level === 1 &&
        rows[R - 1] &&
        Object.values(rows[R - 1]).some(v => v === subHeaders[Number(Object.keys(subHeaders)[0])]?.label)
      ) {
        cell.s = {
          font: { bold: true, name: 'Calibri', sz: 10 },
          fill: { patternType: 'solid', fgColor: { rgb: 'E8F5E9' } },
        }
      } else if (level === 1) {
        cell.s = {
          font: { name: 'Calibri', sz: 10 },
          fill: { patternType: 'solid', fgColor: { rgb: 'E8F5E9' } },
        }
      } else if (level === 0) {
        cell.s = {
          font: { name: 'Calibri', sz: 11 },
        }
      }

      ws[cellAddress] = cell
    }
  }
}
